import React from 'react';
import './BackButton.less';
import Button from '../../../components/envago/Button/Button';
import Icon from '../../../components/envago/Icon/Icon';
import { useIsCompactLayout } from '../../../helper/LayoutHelper';
import { useLocation, useNavigate } from 'react-router';

const BackButton = ({}) => {
    const isCompactLayout = useIsCompactLayout();
    const location = useLocation();

    const navigate = useNavigate();

    const splitLocation = location.pathname.split('/');
    // console.log("location,", location.pathname.split('/'))

    if (splitLocation.length <= 2) return null;

    if (!isCompactLayout) return null;
    return (
        <div className="back-button inline-block mr-2">
            <Button
                aria={{
                    'aria-label': 'Zurück',
                    role: 'button'
                }}
                primary={true}
                onClick={() => {
                    navigate(-1);
                }}
                small={true}
                className={'p-2'}
            >
                <Icon path={Icon.Path.mdiChevronLeft} />
                zurück
            </Button>
        </div>
    );
};

export default BackButton;
